import { useState } from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_lexsant-legal/artifacts/v3889vj4_WhatsApp%20Image%202026-02-17%20at%2016.38.17%20%281%29.jpeg";

export default function DisclaimerPopup() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm px-4">
      <div
        data-testid="disclaimer-popup"
        className="bg-navy-base border border-gold/20 max-w-lg w-full max-h-[90vh] overflow-y-auto"
      >
        {/* Logo */}
        <div className="flex items-center justify-center gap-4 py-8 border-b border-gold/10">
          <img src={LOGO_URL} alt="LexSant" className="h-14 w-14 rounded object-cover" />
          <div className="border-l border-gold/30 pl-4">
            <p className="font-heading text-xl tracking-wider text-white">LEXSANT</p>
            <p className="text-[10px] tracking-[0.35em] uppercase text-gold/60 font-body">Legal & Advisory LLP</p>
          </div>
        </div>

        {/* Content */}
        <div className="px-8 py-8 space-y-6">
          <h3 className="font-heading text-lg tracking-wide text-white">ACKNOWLEDGEMENT</h3>

          <div className="text-sm text-gray-300 font-body leading-relaxed space-y-4">
            <p>
              The rules of the Bar Council of India prohibit lawyers and law firms from soliciting work and advertising. 
              By proceeding further and clicking on the "I AGREE" button herein below, I hereby acknowledge that I, of my 
              own accord, intend to know more and subsequently acquire more information about LexSant Legal & Advisory LLP 
              for my own purpose and use.
            </p>
            <p>
              I further acknowledge that there has been no advertisement, solicitation, communication, invitation or 
              inducement of any sort whatsoever from LexSant Legal & Advisory LLP or any of its members to solicit 
              any work through this website.
            </p>
          </div>

          <button
            onClick={() => setVisible(false)}
            data-testid="disclaimer-agree-btn"
            className="w-full border-2 border-gold/40 text-white py-4 text-sm font-semibold tracking-[0.2em] uppercase font-body hover:bg-gold hover:text-navy-dark transition-all duration-300"
          >
            I Agree
          </button>
        </div>
      </div>
    </div>
  );
}
